/**
 * 네트워크 관련 에러
 * 사용자 네트워크 상태나 브라우저 동작에 의해 발생하는 에러들로, 서비스 로직과 무관합니다.
 */
export const NETWORK_ERROR_PATTERNS = [
  // Fetch/XMLHttpRequest abort 에러
  // 1) AbortController를 사용해서 개발자가 의도적으로 요청을 중단
  // 2) 서드 파티에 의해 요청이 중단 (e.g. react-query)
  // 3) 사용자가 페이지를 닫거나 이동할 때 비동기 요청 중단
  // Sentry Issue: https://zep-us.sentry.io/issues/4462954111/
  'The operation was aborted.',

  // Axios request aborted 에러
  // 사용자가 페이지를 빠르게 이동하거나 네트워크 요청이 중단될 때 발생
  // Sentry Issue: https://zep-us.sentry.io/issues/6192917355/
  'Request aborted',

  // 네트워크 연결 끊김
  'Network request failed',
  'Failed to fetch',
  'NetworkError',

  // Axios 네트워크 에러
  // 사용자 네트워크 불안정, 연결 끊김, 모바일 환경 등에서 발생
  // 주의: 'NetworkError'와 다름 (띄어쓰기 있음)
  'Network Error',

  // Axios 타임아웃 에러 (code: ECONNABORTED)
  // Axios timeout 설정에 의해 요청이 중단된 경우
  // 예: "timeout of 5000ms exceeded"
  /timeout of \d+ms exceeded/,
  'Request timeout',

  // Axios 타임아웃 에러 (최신 버전)
  // Axios 1.x 버전부터 변경된 타임아웃 에러 메시지
  'timeout exceeded',

  /**
   * DOMException: AbortError
   * - fetch/navigation 중단 시 발생하는 에러 (DOMException의 name 속성)
   * - 기존 'The operation was aborted.'(message 속성)와 다른 형태
   * - 사용자가 페이지 이동하거나, React 컴포넌트 unmount 시 진행 중인 fetch가 abort됨
   * - quiz-app에서 특히 빈번 (페이지 전환이 잦은 구조)
   *
   * Added: 2026-02-22 주간 Sentry 노이즈 리포트
   *
   * Sentry Issues:
   * - https://zep-us.sentry.io/issues/QUIZ-APP-1SN (10,925 users, 146,893 events, quiz-app)
   * - https://zep-us.sentry.io/issues/WEB-APP-S1 (23 users, web-app)
   * - https://zep-us.sentry.io/issues/PLAY-APP-7JG (25 users, play-app)
   */
  'AbortError',

  /**
   * Safari 네트워크 에러
   * - Safari에서 네트워크 요청 실패 시 발생하는 에러 메시지
   * - Chrome/Firefox의 'Failed to fetch'에 대응하는 Safari 전용 메시지
   * - 스택트레이스가 없어 디버깅 불가능
   *
   * Sentry Issue:
   * - https://zep-us.sentry.io/issues/QUIZ-APP-3QC (102 users, quiz-app)
   */
  'Load failed',
] as const;
